module.exports = __webpack_public_path__ + "static/media/f3000.08f97425.pdf";